import React from 'react';
import styled from 'styled-components';
import { InfoIcon as Info } from '@gr-monorepo/common/public/assets/icons';
import { useClickStreamContext } from 'features/shared/ClickStream';
import { useLoginModal } from 'features/shared/Login/LoginModalContext';
import { registrationUrl } from '@gr-monorepo/common/public/ui/constants';
import Card from 'features/shared/ui/Card';

const NoticeCard = styled(Card)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const NoticeIcon = styled.div`
  flex-shrink: 0;
  color: var(--primary-base);

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }
`;

const NoticeText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
`;

const NoticeLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: var(--primary-base);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.125s ease-in-out;
`;

const OlympiadsAccessNotice = () => {
  const { openLoginModal } = useLoginModal();
  const { logPageEvent } = useClickStreamContext();

  return (
    <NoticeCard data-testid="olympiads-access-notice">
      <NoticeIcon>
        <Info />
      </NoticeIcon>
      
      <NoticeText>
        <NoticeLink
          type="button"
          data-qa-id="olympiads_notice_login"
          data-testid="olympiads-access-notice-login"
          onClick={() => {
            logPageEvent?.({
              eventType: 'click',
              eventInfo: 'unauth_olympiads_notice_click_entrance',
            });
            openLoginModal();
          }}
        >
          Войдите
        </NoticeLink>
        {' '}в личный кабинет или{' '}
        <NoticeLink
          as="a"
          href={registrationUrl}
          data-qa-id="olympiads_notice_registration"
          data-testid="olympiads-access-notice-registration"
          onClick={() => logPageEvent?.({
            eventType: 'click',
            eventInfo: 'unauth_olympiads_notice_click_registrate',
          })}
        >
          подайте заявку на регистрацию
        </NoticeLink>
        , чтобы получить доступ к отчетам и статистике за предыдущие годы
      </NoticeText>
    </NoticeCard>
  );
};

export default OlympiadsAccessNotice;